import type { Lens } from '@hookform/lenses';
import { z } from 'zod/v4';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { IxcRegistrationV1EmploymentEmployed } from '@interxfi/types/generated/api';
import { AppTextInputWithLens } from '../../../../../../components/form/app-text-input';

export const employedFormSchema = z.object({
  kind: z.literal('employed'),
  value: z.object({
    institution: z.string().nonempty({ error: 'Institution is required' }),
    occupation: z.string().nonempty({ error: 'Occupation is required' }),
  }),
});

type EmployedFormValues = z.infer<typeof employedFormSchema>;

export const defaultEmployedFormValues: EmployedFormValues = {
  kind: 'employed',
  value: {
    institution: '',
    occupation: '',
  },
};

export function getInitialFormValuesForEmployed(data: IxcRegistrationV1EmploymentEmployed | undefined): EmployedFormValues {
  return {
    ...defaultEmployedFormValues,
    value: {
      institution: data?.institution ?? '',
      occupation: data?.occupation ?? '',
    },
  };
}

export function formValuesToEmployed(values: EmployedFormValues): IxcRegistrationV1EmploymentEmployed {
  return {
    institution: values.value.institution.trim(),
    occupation: values.value.occupation.trim(),
  };
}

interface EmploymentEmployedFormProps {
  lens: Lens<EmployedFormValues>;
}

export function EmploymentEmployedForm({ lens }: EmploymentEmployedFormProps) {
  return (
    <VerticalStack gap={4}>
      <AppTextInputWithLens label="Occupation" lens={lens.focus('value.occupation')} required />
      <AppTextInputWithLens label="Institution" lens={lens.focus('value.institution')} required />
    </VerticalStack>
  );
}
